import { module } from 'stereomodularjs';
import {Swiper, Scrollbar } from 'swiper';
// Import navigation module from swiper


export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        // Ensure the scrollbar element is available
        const scrollbarEl = document.querySelector('.swiper-scrollbar-single-car');
        console.log('Scrollbar element:', scrollbarEl);
        if (!scrollbarEl) {
            console.error('Scrollbar element not found');
            return;
        }

        this.swiper = new Swiper(this.el, {
            modules: [Scrollbar],
            scrollbar: {
                el: scrollbarEl,
                dragSize: 15,
                draggable: true,
            },
            on: {
                slideChange: (e) => {
                    let currentSlide = e.activeIndex;
                    let totalSlides = e.slides.length;
                    document.querySelector('.js-slider-index-num').innerHTML = `${currentSlide + 1}`;
                    if (currentSlide == 0) {
                        document.querySelector('.c-single-car-slider__button.-prev').classList.add('-disabled');
                    } else {
                        document.querySelector('.c-single-car-slider__button.-prev').classList.remove('-disabled');
                    }
                    if (currentSlide == totalSlides - 1) {
                        document.querySelector('.c-single-car-slider__button.-next').classList.add('-disabled');
                    } else {
                        document.querySelector('.c-single-car-slider__button.-next').classList.remove('-disabled');
                    }
                },
            },
        });

        document.querySelector('.c-single-car-slider__button.-next').addEventListener('click', () => {
            this.swiper.slideNext();
        });
        document.querySelector('.c-single-car-slider__button.-prev').addEventListener('click', () => {
            this.swiper.slidePrev();
        });
    }
    
}
 